module.exports = __webpack_public_path__ + "media/images/product_lines/motorcycle/info-a76ec2911858f3118b8352408eea71eb.svg";